import ArrowLeftIcon from './ArrowLeftIcon'

export default ArrowLeftIcon
